<template>
  <div>
    <custom-select
      :list="filteredList"
      :data="data"
      :label="label"
      :is-content-loading="regionsAreLoading"
      :no-data-text-prop="noDataText"
      :rules="rules"
      type="regions"
      search-label="Поиск регионов"
      search
      chips
      multiple
      @change="onChange"
      @search="onSearch"
    />
  </div>
</template>

<script>
import CustomSelect from '@/components/ui/custom-select';

export default {
  name: 'additional-regions-select',

  components: {
    CustomSelect,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    itemsList: {
      type: Array,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },

    excludedList: {
      type: Array,
      default: () => ([]),
    },

    regionsAreLoading: {
      type: Boolean,
      default: false,
    },

    rules: {
      type: Array,
      default: () => ([]),
    },

    value: [Object, Array],
    data: [Object, Array],
  },

  data: () => ({
    query: '',
  }),

  computed: {
    filteredList() {
      return this.itemsList.filter((region) => !this.excludedList.includes(region.id));
    },

    noDataText() {
      if (this.regionsAreLoading) {
        return '';
      }

      if (this.query.length > 2 && !this.itemsList.length) {
        return 'Доступный регион не найден';
      }

      return 'Введите текст для поиска региона';
    },
  },

  methods: {
    async onSearch(query) {
      this.query = query;
      this.$emit('search', query);
    },

    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
